import React, { useState, useEffect } from "react";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";

export const GeneralStatsPie = ({ generalStats }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let workingArray = [
      {
        id: "ON SPOT",
        label: "ON SPOT",
        value: generalStats.ordersEatInSuccess.length,
        totalSum: generalStats.totalSumEatIn,
        averageOrder:
          generalStats.ordersEatInSuccess.length > 0
            ? Math.round(
                generalStats.totalSumEatIn /
                  generalStats.ordersEatInSuccess.length
              )
            : "",
        onSpotSum: generalStats.eatinSumOnSpot,
        averageOrderOnSpot:
          generalStats.ordersEatInSuccess.filter(
            (o) => o.orderPaymentType === "onSpot"
          ).length > 0
            ? Math.round(
                generalStats.eatinSumOnSpot /
                  generalStats.ordersEatInSuccess.filter(
                    (o) => o.orderPaymentType === "onSpot"
                  ).length
              )
            : "",
        onlineSum: generalStats.eatinSumOnline,
        averageOrderOnline:
          generalStats.ordersEatInSuccess.filter(
            (o) => o.orderPaymentType === "online"
          ).length > 0
            ? Math.round(
                generalStats.eatinSumOnline /
                  generalStats.ordersEatInSuccess.filter(
                    (o) => o.orderPaymentType === "online"
                  ).length
              )
            : "",
        color: "rgb(57, 235, 51)"
      },
      {
        id: "TAKEAWAY",
        label: "TAKEAWAY",
        value: generalStats.ordersTakeOutSuccess.length,
        totalSum: generalStats.totalSumTakeOut,
        averageOrder:
          generalStats.ordersTakeOutSuccess.length > 0
            ? Math.round(
                generalStats.totalSumTakeOut /
                  generalStats.ordersTakeOutSuccess.length
              )
            : "",
        onSpotSum: generalStats.takeoutSumOnSpot,
        averageOrderOnSpot:
          generalStats.ordersTakeOutSuccess.filter(
            (o) => o.orderPaymentType === "onSpot"
          ).length > 0
            ? Math.round(
                generalStats.takeoutSumOnSpot /
                  generalStats.ordersTakeOutSuccess.filter(
                    (o) => o.orderPaymentType === "onSpot"
                  ).length
              )
            : "",
        onlineSum: generalStats.takeoutSumOnline,
        averageOrderOnline:
          generalStats.ordersTakeOutSuccess.filter(
            (o) => o.orderPaymentType === "online"
          ).length > 0
            ? Math.round(
                generalStats.takeoutSumOnline /
                  generalStats.ordersTakeOutSuccess.filter(
                    (o) => o.orderPaymentType === "online"
                  ).length
              )
            : "",
        color: "rgb(51, 195, 235)"
      },
      {
        id: "CANCELLED",
        label: "CANCELLED",
        value: generalStats.cancelledOrders.length,
        color: "rgb(235, 51, 51)"
      }
    ];

    setData([...workingArray]);
  }, [generalStats]);

  return (
    <ResponsivePie
      data={data}
      margin={{ top: 20, right: 0, bottom: 60, left: 0 }}
      innerRadius={0.5}
      padAngle={2}
      cornerRadius={6}
      colors={(d) => d.color}
      borderWidth={1}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      radialLabelsSkipAngle={10}
      radialLabelsTextXOffset={6}
      radialLabelsTextColor="#333333"
      radialLabelsLinkOffset={0}
      radialLabelsLinkDiagonalLength={5}
      radialLabelsLinkHorizontalLength={20}
      radialLabelsLinkStrokeWidth={1}
      radialLabelsLinkColor={{ from: "color" }}
      slicesLabelsSkipAngle={10}
      slicesLabelsTextColor="white"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      tooltip={({
        id,
        value,
        color,
        totalSum,
        onSpotSum,
        onlineSum,
        averageOrder,
        averageOrderOnSpot,
        averageOrderOnline
      }) =>
        id === "TAKEAWAY" || id === "ON SPOT" ? (
          <div>
            <strong style={{ color }}>{id}</strong>
            <br />
            <strong style={{ color }}>Overall orders: {value}</strong>
            <br />
            <strong style={{ color }}>Total sum: {totalSum} $</strong>
            <br />
            <strong style={{ color }}>Average sum: {averageOrder} $</strong>
            {averageOrderOnSpot ? (
              <>
                <br />
                <strong style={{ color }}>On spot sum: {onSpotSum} $</strong>
                <br />
                <strong style={{ color }}>
                  Average order on spot: {averageOrderOnSpot} $
                </strong>
                <br />
              </>
            ) : null}
            {averageOrderOnline ? (
              <>
                <br />
                <strong style={{ color }}>Online sum: {onlineSum} $</strong>
                <br />
                <strong style={{ color }}>
                  Average online order: {averageOrderOnline} $
                </strong>
              </>
            ) : null}
          </div>
        ) : (
          <div>
            <strong style={{ color }}>{id}</strong>
            <br />
            <strong style={{ color }}>Overall orders: {value}</strong>
          </div>
        )
      }
      theme={{
        tooltip: {
          container: {
            background: "#333"
          }
        }
      }}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          translateY: 56,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: "#999",
          symbolSize: 18,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: "#000"
              }
            }
          ]
        }
      ]}
    />
  );
};

export const PopularDishesBar = ({ rawData }) => {
  const [data, setData] = useState([]);
  const [keys, setKeys] = useState([]);

  useEffect(() => {
    let workingKeys = rawData.map((item) => item.name);

    let workingData = [];

    rawData.forEach((item) => {
      let workingObject = {
        name: item.name
      };
      workingObject[`${item.name}`] = item.orderedTimes;

      workingData.push(workingObject);
    });

    setData([...workingData]);

    setKeys([...workingKeys]);
  }, [rawData]);

  return (
    <ResponsiveBar
      data={data}
      keys={keys}
      indexBy="name"
      margin={{ top: 0, right: 0, bottom: 0, left: 50 }}
      padding={0.3}
      colors={{ scheme: "nivo" }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "servings ordered",
        legendPosition: "middle",
        legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
    />
  );
};
